/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetServiceRequest = {
  id: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type GetServiceResponse =
  | components.ComputeService
  | components.ComputeErrorEnvelope;

/** @internal */
export const GetServiceRequest$inboundSchema: z.ZodType<
  GetServiceRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetServiceRequest$Outbound = {
  id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetServiceRequest$outboundSchema: z.ZodType<
  GetServiceRequest$Outbound,
  z.ZodTypeDef,
  GetServiceRequest
> = z.object({
  id: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getServiceRequestToJSON(
  getServiceRequest: GetServiceRequest,
): string {
  return JSON.stringify(
    GetServiceRequest$outboundSchema.parse(getServiceRequest),
  );
}
export function getServiceRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetServiceRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetServiceRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetServiceRequest' from JSON`,
  );
}

/** @internal */
export const GetServiceResponse$inboundSchema: z.ZodType<
  GetServiceResponse,
  z.ZodTypeDef,
  unknown
> = z.union([
  components.ComputeService$inboundSchema,
  components.ComputeErrorEnvelope$inboundSchema,
]);
/** @internal */
export type GetServiceResponse$Outbound =
  | components.ComputeService$Outbound
  | components.ComputeErrorEnvelope$Outbound;

/** @internal */
export const GetServiceResponse$outboundSchema: z.ZodType<
  GetServiceResponse$Outbound,
  z.ZodTypeDef,
  GetServiceResponse
> = z.union([
  components.ComputeService$outboundSchema,
  components.ComputeErrorEnvelope$outboundSchema,
]);

export function getServiceResponseToJSON(
  getServiceResponse: GetServiceResponse,
): string {
  return JSON.stringify(
    GetServiceResponse$outboundSchema.parse(getServiceResponse),
  );
}
export function getServiceResponseFromJSON(
  jsonString: string,
): SafeParseResult<GetServiceResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetServiceResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetServiceResponse' from JSON`,
  );
}
